import { useParams } from 'react-router';
import { StudentLoader } from '../../../../../updateStudentFile/parts/StudentObservations/Loaders/StudentLoader';
import { StudentObservationFormLoader } from '../../../../../updateStudentFile/parts/StudentObservations/Loaders/StudentObservationFormLoader';
import { StudentObservationsLoader } from '../../../../../updateStudentFile/parts/StudentObservations/Loaders/StudentObservationsLoader';
import { StudentActionsLoader } from '../../../loaders/StudentActionsLoader';
import StudentActionsTable from '../../../StudentActionsTable';
import StudentObservations from './StudentObservations';

const StudentObservationGroup = () => {
  const { studentId } = useParams<{ studentId: string }>();
  return (
    <div className="w-100 d-flex flex-column mt-3 pl-5" style={{ gap: 12 }}>
      <div className="mt-2">
        <StudentActionsLoader defaultQuery={{ studentId }} fetchImmediately>
          <StudentActionsTable />
        </StudentActionsLoader>
      </div>
      <div className="mt-2">
        <StudentObservationFormLoader fetchImmediately>
          <StudentLoader
            defaultQuery={{
              studentId,
            }}
            fetchImmediately
          >
            <StudentObservationsLoader
              defaultQuery={{
                studentId,
                items_per_page: 10,
                page: 1,
              }}
              fetchImmediately
            >
              <StudentObservations />
            </StudentObservationsLoader>
          </StudentLoader>
        </StudentObservationFormLoader>
      </div>
    </div>
  );
};

export default StudentObservationGroup;
